// extracted by mini-css-extract-plugin
export default {"table":"MarketingTermsAndConditionsPage-module__table__FH_zg"};